var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"product-grid",class:{single: _vm.products.length === 1}},_vm._l((_vm.products),function(product){return _c('ProductBox',{key:product.id,attrs:{"product":product,"webshop":_vm.webshop,"checkout":_vm.checkout,"save-handler":_vm.saveHandler,"admin":_vm.admin}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }